import React from 'react';
import { Link, Redirect } from 'wouter';

import { MicromagItem } from '../../types/micromag';
import PageMeta from '../partials/PageMeta';
import Thumbnail from '../partials/Thumbnail';

import logo from '../../img/logo.svg';
import styles from '../../styles/pages/home.module.css';

interface HomePageProps {
    screen?: string | null;
    micromags?: MicromagItem[] | null;
}

function HomePage({ micromags = null }: HomePageProps) {
    // if (micromags === null || micromags.length === 0) {
    //     return <div className={styles.container} />;
    // }

    const [first = null, ...others] = micromags || [];
    if (micromags !== null && micromags.length === 1 && first !== null) {
        const { slug = null } = first || {};
        return slug !== null ? <Redirect to={`/${slug}`} /> : null;
    }

    return (
        <div className={styles.container}>
            <PageMeta title="Magazines La Poste" />
            <div className={styles.inner}>
                <div className={styles.hero}>
                    {first !== null && (
                        <Link className={styles.heroLink} key={first.slug} href={`/${first.slug}`}>
                            <Thumbnail
                                className={styles.heroThumbnail}
                                innerClassName={styles.heroVideo}
                                micromag={first}
                            />
                        </Link>
                    )}
                    <div className={styles.heroInfo}>
                        {/* <img className={styles.logo} src={logo} /> */}
                        {/* <p className={styles.description}>
                            <strong>
                                <em>Magazines La Poste</em>
                            </strong>
                        </p> */}
                        <p className={styles.description}>À découvrir sous peu...</p>
                    </div>
                </div>
                {/* <div className={styles.items}>
                    <div className={styles.grid}>
                        {(micromags || []).map((micromag, index) => (
                            <Link
                                className={styles.cellLink}
                                key={`${micromag.slug}-${index}`}
                                href={`/${micromag.slug}`}
                            >
                                <Thumbnail
                                    innerClassName={styles.cell}
                                    micromag={micromag}
                                    withInfo
                                    isPoster
                                />
                            </Link>
                        ))}
                    </div>
                </div> */}
            </div>
        </div>
    );
}

export default HomePage;
